import React from 'react';
import DraggableModal from 'components/DraggableModal';
import {DialogTypes} from 'common/names';
import SearchTransactionForm from './SearchTransactionForm';
import {openDialogOutside} from 'common/openDialogOutside';

type SearchTransactionDialogProps = {
   header: string;
   onClose: () => void;
};

const SearchTransactionDialog = ({header, onClose}: SearchTransactionDialogProps) => {
   const openOutside = React.useCallback(
      () => openDialogOutside(DialogTypes.SearchTransactionsDialog.id),
      []
   );

   return (
      <DraggableModal width={'md'} header={header} onClose={onClose} onLaunch={openOutside}>
         <SearchTransactionForm onClose={onClose} />
      </DraggableModal>
   );
};

export default React.memo(SearchTransactionDialog);
